<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="d-flex ma-3">
        <div class="topic_breadcrumb_header border_right">แก้ไขข้อมูลสินค้า</div>
        <div class="topic_breadcrumb_content ma-2">ระบบ POS</div>
        <div class="topic_breadcrumb_content ma-2"> > </div>
        <div class="topic_breadcrumb_content ma-2">คลังสินค้า</div>
        <div class="topic_breadcrumb_content ma-2"> > </div>
        <div class="topic_breadcrumb_content ma-2">รายการสินค้า/บริการ</div>
        <div class="topic_breadcrumb_content ma-2"> > </div>
        <div class="topic_breadcrumb_content ma-2">แก้ไขข้อมูลสินค้า</div>
      </div>
      <div class="mt-5">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
          <template>
            <v-form ref="setting">
              <v-timeline align-top dense>
                <v-timeline-item fill-dot color="#D6BFAF">
                  <template v-slot:icon>
                    <div class="logo_timeline mx-auto my-auto">
                      <img src="@/assets/arin_assets/box.png">
                    </div>
                  </template>
                  <div class="d-flex" style="margin-top: 2px">
                    <div class="header-content py-1 pl-5 pr-3 text-center">
                      <div class="content-font">ข้อมูลสินค้า</div>
                    </div>
                  </div>
                  <section class="mt-5">
                    <div class="image_grid">
                      <div class="mt-3">
                        <div class="text_title mt-2">รูปภาพสินค้า </div>
                        <div class="ma-4" style="position: relative">
                          <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :lazy-src="img_holder" :src="imagePreviewURL" class="preview"></v-img>
                          <v-img height="300" max-width="300" v-else :lazy-src="img_holder" :src="img_holder" class="preview"></v-img>
                          <div class="file_input_style">
                            <v-btn elevation="3" class="ma-2" outlined small height="45" color="#FEA06C" style="border-radius: 10px;background-color: #FFFFFF" title="อัพโหลดโลโก้">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div class="pa-2 mx-auto my-auto">
                        <v-btn elevation="0" outlined x-large height="80" color="#D9D9D9" style="border-radius: 15px;background-color: #FFFFFF" title="เพิ่มรูปภาพ">
                          <v-icon size="48">mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="input_half">
                      <section class="pa-2">
                        <div class="text_title mt-2">ชื่อสินค้า <span class="red--text">*</span></div>
                        <div class="mt-2">
                          <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cube" hide-details="auto" required v-model="input_set.product_name" placeholder="กรุณากรอกชื่อสินค้า" outlined></v-text-field>
                        </div>
                      </section>
                      <section class="pa-2">
                        <div class="text_title mt-2">ชื่อทางการแพทย์</div>
                        <div class="mt-2">
                          <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-credit-card" hide-details="auto" required v-model="input_set.sci_name" placeholder="กรุณากรอกชื่อทางการแพทย์" outlined></v-text-field>
                        </div>
                      </section>
                      <section class="pa-2">
                        <div class="text_title mt-2">ประเภทสินค้า <span class="red--text">*</span></div>
                        <div class="mt-1">
                          <v-autocomplete color="#D6BFAF" class="input-radius" :items="banking_list" item-text="banking_name" item-value="id" v-model="input_set.product_type" hide-details="auto" placeholder="กรุณาเลือกประเภทสินค้า" outlined></v-autocomplete>
                        </div>
                      </section>
                      <section class="pa-2">
                        <div class="text_title mt-2">จำนวนสินค้าในคลังไม่ควรน้อยกว่า <span class="red--text">*</span></div>
                        <div class="mt-1">
                          <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cube" hide-details="auto" required v-model="input_set.min_qty" placeholder="กรุณากรอกจำนวนสินค้าในคลังไม่ควรน้อยกว่า" outlined></v-text-field>
                        </div>
                      </section>
                    </div>
                    <div class="input_full">
                      <section class="pa-2">
                        <div class="text_title mt-2">รายละเอียด</div>
                        <div class="mt-1">
                          <v-textarea color="#D6BFAF" class="input-radius" hide-details="auto" required v-model="input_set.note" placeholder="กรุณากรอกรายละเอียด" outlined></v-textarea>
                        </div>
                      </section>
                    </div>
                  </section>
                </v-timeline-item>
                <v-timeline-item fill-dot color="#D6BFAF">
                  <template v-slot:icon>
                    <div class="logo_timeline mx-auto my-auto">
                      <img src="@/assets/arin_assets/cycle.png">
                    </div>
                  </template>
                  <div class="d-flex" style="margin-top: 2px">
                    <div class="header-content py-1 pl-5 pr-3 text-center">
                      <div class="content-font">ข้อมูลหน่วยนับ</div>
                    </div>
                  </div>
                  <section class="mt-5">
                    <div class="grid_unit">
                      <div class="pa-2">
                        <div class="text_title mt-2">หน่วยนับ <span class="red--text">*</span></div>
                        <div class="mt-1">
                          <v-autocomplete color="#D6BFAF" class="input-radius" :items="banking_list" item-text="banking_name" item-value="id" v-model="input_set.unit_id" hide-details="auto" placeholder="กรุณาเลือกหน่วยนับ" outlined></v-autocomplete>
                        </div>
                      </div>
                      <div class="pa-2">
                        <div class="text_title mt-2">บาร์โค๊ด <span class="red--text">*</span></div>
                        <div class="d-flex">
                          <div class="mt-1 width_input">
                            <v-text-field color="#D6BFAF" class="input-radius" v-model="input_set.barcode" hide-details="auto" placeholder="กรุณากรอกบาร์โค๊ด" outlined></v-text-field>
                          </div>
                          <div class="ml-5 my-auto">
                            <v-btn elevation="3" @click="make_id" outlined small height="50" color="#8EBBDC" style="border-radius: 10px;background-color: #FFFFFF" title="ดูรายละเอียด">
                              <v-icon>mdi-barcode</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <div class="pa-2">
                        <div class="text_title mt-2">ราคาขายปลีก <span class="red--text">*</span></div>
                        <div class="d-flex">
                          <div class="mt-1 width_input">
                            <v-text-field color="#D6BFAF" class="input-radius" v-model="input_set.retail_price" hide-details="auto" placeholder="กรุณากรอกราคาขายปลีก" outlined></v-text-field>
                          </div>
                          <div class="ml-5 my-auto">
                            <v-btn elevation="3" outlined small height="50" color="#F28080" style="border-radius: 10px;background-color: #FFFFFF" title="ลบ">
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-end">
                      <v-btn elevation="3" class="ma-2" outlined height="45" color="#88B358" style="border-radius: 10px;background-color: #FFFFFF" title="เพิ่มหน่วยนับ">
                        เพิ่มหน่วยนับ
                      </v-btn>
                    </div>
                  </section>
                </v-timeline-item>
              </v-timeline>
              <div class="text-center mt-6 mb-3">
                <v-btn type="submit" height="45" class="white--text grad-success-arin-bg mobile_btn" style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
              </div>
            </v-form>
          </template>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import img_holder_document from "@/assets/arin_assets/image_document.png";
import img_holder_cert from "@/assets/arin_assets/image_certification.png";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_edit_product_service",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      img_holder_document: img_holder_document,
      img_holder_cert: img_holder_cert,
      imagePreviewURL: null,
      input_set: {
        product_name: '',
        sci_name: '',
        note: '',
        min_qty: 0,
        product_type: '',
        unit_id: '',
        barcode: '',
        retail_price: '',
      },
      banking_list: [
        {id: 1, banking_name: 'ธนาคารกรุงเทพ'},
        {id: 2, banking_name: 'ธนาคารกรุงไทย'},
        {id: 3, banking_name: 'ธนาคารทหารไทย'},
      ],
      unit_list: [
        {id: 1, name: 'Box(O)'},
        {id: 2, name: 'Box(100)'},
        {id: 3, name: 'table(23)'},
      ],
    }
  },
  methods: {
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.input_set.system_logo = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.input_set.system_logo = null
          }
        }
      }else {
        this.imagePreviewURL = null
        this.input_set.system_logo = null
      }
    },
    make_id() {
      this.input_set.barcode = ''
      let characters_number = '0123456789';
      // let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters_number.length;
      for ( let i = 0; i < 9; i++ ) {
        this.input_set.barcode += characters_number.charAt(Math.floor(Math.random() * charactersLength));
      }
    }
  },
}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}
.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}
/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */
.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}
.logo_timeline {
  width: 25px;
  height: 25px;
}
.logo_timeline>img {
  max-width: 25px;
}
.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}
.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}
.radio_half {
  display: grid;
  grid-template-columns: 25%;
}
.v-otp-input .v-input {
  padding: 10px !important
}
.input-radius {
  border-radius: 10px;
}
.grid_radio {
  display: flex;
  justify-content: space-between;
}
.btn_width {
  width: 50%;
}
.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}
.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.mobile_btn {
  width: 15%;
}
.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}
.preview {
  border-radius: 10px;
}
.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.image_grid {
  display: grid;
  grid-template-columns: 22% 22% 22% 14%;
}
.input_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_unit {
  display: grid;
  grid-template-columns: 30% 30% 30%;
}
.width_input {
  width: 100%;
}
</style>
